import Button from '../../../../components/Button/Button';
import DownloadFileLink from '../../../../components/DownloadFileLink/DownloadFileLink';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import FormHeading from '../../../../components/Typography/FormHeading';
import { DOCUMENT_TYPES_GUARANTEE_LETTER } from '../../../../constants';

const HalykNotarialDocuments = ({ documents, backHandler, onSubmit, loading }) => {
  // const guaranteeLetter = documents?.find((doc) => doc?.type?.id === DOCUMENT_TYPES_GUARANTEE_LETTER);

  return (
    <div>
      {/* {guaranteeLetter && (
        <>
          <FormHeading>Ð¡ÐºÐ°ÑÐ°ÑÑ Ð³Ð°ÑÐ°Ð½ÑÐ¸Ð¹Ð½Ð¾Ðµ Ð¿Ð¸ÑÑÐ¼Ð¾</FormHeading>
          <DownloadFileLink document={guaranteeLetter} />
        </>
      )} */}

      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        hint="ÐÑÐ¾ÐºÐ¾Ð½ÑÑÐ»ÑÑÐ¸ÑÑÐ¹ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÐºÐ°ÐºÐ¸Ðµ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸ Ð¸ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð°Ð´Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ. ÐÑÐ¶Ð½Ð¾ ÑÑÐ¾Ð±Ñ ÐºÐ»Ð¸ÐµÐ½Ñ Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» ÑÐ°Ð²Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð¾ÑÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸, ÑÑÐ¾ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð´Ð»Ñ ÑÐ¾Ð³Ð¾, ÑÑÐ¾Ð±Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð²ÑÐ¿Ð¸ÑÐ°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ñ Ð»ÑÐ±Ð¾Ð³Ð¾ Ð½Ð¾ÑÐ°ÑÐ¸ÑÑÐ°. Â Â Ð¢Ð°Ðº Ð¶Ðµ Ð½ÑÐ¶Ð½Ð¾ Ð¾Ð¿Ð¸ÑÐ°ÑÑ Ð½Ð° ÐºÐ¾Ð³Ð¾ Ð½ÑÐ¶Ð½Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð½Ð° ÑÑÐµÑ. ÐÑÐ¿Ð¸ÑÐ°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð½ÑÐ¶Ð½Ð¾ Ð½Ð° Ð¤ÐÐ, ÐÐÐ ÑÐµÐ»Ð¾Ð²ÐµÐºÐ°."
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            text: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ',
            id: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            component: DocsInputNew,
            required: true,
          },
          {
            text: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ',
            id: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ',
            component: DocsInputNew,
          },
          {
            label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸',
            name: 'powerOfAttorneyNumber',
          },
        ]}
        onSubmit={onSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default HalykNotarialDocuments;
